<template>
  <div class="appendix-section skinc-container">
    <AppendixTop />
    <AppendixBottom />
  </div>
</template>

<script>
import AppendixTop from './AppendixTop.vue';
import AppendixBottom from './AppendixBottom.vue';

export default {
  name: 'AppendixLayout',
  components: {
    AppendixTop,
    AppendixBottom
  }
};
</script>

<style scoped>
.appendix-section {
  width: 100%;
  min-height: 60vh;
  padding-top: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #fff;
}
</style>
